// import React from 'react';
// import ReactDOM from 'react-dom/client';
// // import './index.css';
// import App from './App';
// import 'bootstrap/dist/css/bootstrap.min.css';
// import './App.css'

// const root = ReactDOM.createRoot(document.getElementById('root'));
// root.render(
//   <React.StrictMode>
//     <App />
//   </React.StrictMode>
// );

import React from "react";
import ReactDOM from "react-dom/client";
import { PostHogProvider } from "@posthog/react";
import * as Sentry from "@sentry/react";
import App from "./App";
import "bootstrap/dist/css/bootstrap.min.css";
import "./App.css";
Sentry.init({
  // dsn: "https://16f7e394cbb081793bebb090043f8e97@o4511274373283840.ingest.us.sentry.io/4511274387701760",
  dsn: process.env.REACT_APP_SENTRY_DSN,
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true,
  integrations: [
    Sentry.browserTracingIntegration(),
    // Sentry.replayIntegration()
  ],
  // Tracing
  //  environment: process.env.NODE_ENV,
  environment: process.env.REACT_APP_ENV || "production",
  tracesSampleRate: 1.0, //  Capture 100% of the transactions
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: ["localhost", process.env.REACT_APP_BASE_URL],
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.,
  // Enable logs to be sent to Sentry
  enableLogs: true,
});
const posthogOptions = {
  api_host: process.env.REACT_APP_POSTHOG_HOST,
  session_recording: {
    maskAllInputs: false,
    maskTextSelector: "[data-mask]", // only mask elements with this attribute
  },
  disable_session_recording: false,
  loaded: (ph) => {
    ph.startSessionRecording();
    if (process.env.NODE_ENV === 'development') ph.opt_out_capturing();
    Sentry.addEventProcessor((event) => {
      event.tags = {
        ...event.tags,
        posthog_session_url: ph.get_session_replay_url?.({
          withTimestamp: true,
        }),
      };
      return event;
    });
  },
};
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  // <React.StrictMode>
  <PostHogProvider
    apiKey={process.env.REACT_APP_POSTHOG_TOKEN}
    options={posthogOptions}
  >
    <Sentry.ErrorBoundary
      fallback={<p>Something went wrong. Our team has been notified.</p>}
    >
      <App />
    </Sentry.ErrorBoundary>
  </PostHogProvider>,
  // </React.StrictMode>
);
